export default {
  addApp: "Agregar aplicación",
  addButton: "Agregar Activos",
  addBillingAddress: "Agregar Dirección de Facturación",
  addModelButton: "Agregar Modelo",
  addManufacturerButton: "Agregar Fabricante",
  columnOptions: "Opciones de Columna",
  delete: "eliminar",
  density: "densidad",
  compact: "compacto",
  standard: "estándar",
  comfortable: "cómodo",
  edit: "editar",
  filter: "filtrar",
  deleteTenants: "Eliminar Organizaciones",
  checkboxSelection: "Selección de Casilla",
  importAssets: "Importar Activos",
  exportAllContacts: "Exportar todos los contactos",
  exportAllAssets: "Exportar todos los Activos",
  removeApp: "Eliminar aplicación",
  rowsPerPage: "Filas por página",
  search: "Buscar",
  filterValue: "Valor de filtro",
  searchTable: "Buscar en tabla",
  serialNo: "No. de serie",
  findColumn: "Buscar columna",
  sort: "ordenar",
  tags: "Etiquetas",
  gotIt: "Entendido",
  deleteNotPossible: "Eliminación no posible",
  editUser: "Editar Usuario",
  blockUser: "Bloquear Usuario",
  unblockUser: "Desbloquear Usuario",
  editTenant: "Editar Organización",
  noData: "No Hay Datos Disponibles",
};
